import {
    GET_STORE_LIST_PROGRESS, GET_STORE_LIST_SUCCESS, GET_STORE_LIST_FAILURE,
    ADD_STORE_PROGRESS, ADD_STORE_SUCCESS, ADD_STORE_FAILURE,
    EDIT_DELETE_STORE_PROGRESS, EDIT_DELETE_STORE_SUCCESS, EDIT_DELETE_STORE_FAILURE,
   
    RESET_MESSAGE,

} from '../types/actionTypes';

const initialState = {
    store: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const store_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_STORE_LIST_SUCCESS:
            return { ...state, store: action.store, loading: false };
        case GET_STORE_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_STORE_LIST_PROGRESS:
            return { ...state, loading: true, error: false };
        case ADD_STORE_PROGRESS:
            return { ...state, loading: true };
        case ADD_STORE_SUCCESS:
            return { ...state, store: [...state.store, action.payload], loading: false, error: false, message: 'Record saved successfully!' };
        case ADD_STORE_FAILURE:
            return { ...state, loading: false, error: action.payload, message: 'Failed to save the record, try again!' };
        case EDIT_DELETE_STORE_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_STORE_SUCCESS:
            return {
                ...state,
                store: state.store.map((store) =>
                store._id === action.payload._id ? action.payload : store
                ),
                message: action.payload.is_deleted === 1 ? 'Record deleted successfully!' : 'Record updated successfully!'
            };
        case EDIT_DELETE_STORE_FAILURE:
            return { ...state, loading: false, error: action.payload, message: 'Failed to update the record, try again!' };
     
        case RESET_MESSAGE:
            return { ...state, message: null }; // Reset the edit message

        default:
            return state
    }
}

export default store_reducer;